import { Alert, Col, Form, Input, Radio, Row } from "antd";
import React from "react";
import "./StepsOrg.scss";
import { observaciones, radioButton } from "../../../../utils/rules";
import { base64ToBlob } from "../../../../utils/Others/function";
import { useState } from "react";
import { useEffect } from "react";

export default function ValidaContOrg(props) {

    const { organizacion, onChangeRadio, form, observacionesAux, disabled } = props;

    //Para poder visualizar pdfs grandes es necesario convertir de base64 a objeto blob
    const blob = base64ToBlob( organizacion.urlSolicitudVista, 'application/pdf' );
    const [url, setUrl] = useState();
    const [telefonoForm, setTelefonoForm] = useState("");

    useEffect(() => {

        //Se crea objeto url para visualizar el pdf que apunta al objeto blob creado, se usa en el useEffect
        //para que solo renderize una vez el pdf y no al estar contestando las preguntas
        setUrl(URL.createObjectURL( blob ));
        //Damos formato al telefono si se capturo ceros al inicio 
        setTelefonoForm(organizacion.telefono);
        if (organizacion.telefono && organizacion.telefono.toString().length < 10) {
            var faltanteTel = 10 - organizacion.telefono.toString().length;
            var finalTel = organizacion.telefono.toString();
            for (let i = 0; i < faltanteTel; i++) {
                finalTel = "0" + finalTel;
            }
            setTelefonoForm(finalTel);
          }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Row gutter={20}>
                <Col span={12}>

                    <h4>Soporte documental</h4>

                    {organizacion.urlSolicitudVista !== null ? (
                        <>
                            <embed  src={url}
                                    type="application/pdf"
                                    width="100%"
                                    height="400px" />
                        </>
                    ) : (
                        <>
                            <Alert  message="No se cargó el soporte documental."
                                    type="info" 
                                    showIcon />
                        </>
                    )}
                </Col>
                <Col span={12}>

                    <h4>Datos capturados</h4>

                    <div className="datosCapturados">

                        <Row>
                            <Col span={24} className="paddingDatos">
                                <b>Datos de contacto</b>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={24} className="paddingDatos">
                                <b>Teléfono</b><br/>
                                {telefonoForm}
                            </Col>
                        </Row>

                        <Form form={form} layout="vertical">

                            <Row>
                                <Col span={24} className="paddingDatos">

                                    <Form.Item  label="¿Los datos son correctos?" 
                                                style={{fontWeight: "bold"}}
                                                name="validaContOrg"
                                                rules={ radioButton }
                                                initialValue={ observacionesAux.validaContOrg } >

                                        <Radio.Group    onChange={onChangeRadio("validaContOrg")} 
                                                        style={{fontWeight: "normal"}}
                                                        disabled={disabled.validaContOrg} >

                                            <Radio value={true}>Sí</Radio>
                                            <Radio value={false}>No</Radio>

                                        </Radio.Group>

                                    </Form.Item>

                                </Col>
                            </Row>
                            {form.getFieldValue("validaContOrg") === false && (
                            <Row>
                                <Col span={24} className="paddingObs">

                                    <Form.Item  label="Observaciones" 
                                                style={{fontWeight: "bold"}}
                                                name="validaContOrgObs"
                                                rules={ observaciones }
                                                initialValue={ observacionesAux.validaContOrgObs } >

                                        <Input.TextArea onChange={onChangeRadio("validaContOrgObs")}
                                                        maxLength={150} 
                                                        disabled={disabled.validaContOrg} />

                                    </Form.Item>

                                </Col>
                            </Row>
                            )}
                        </Form>
                    </div>
                </Col>
            </Row>
        </>
    );

}